/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Email_IntegrationInputs */

const en_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email integration`)
};

const de_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Integration`)
};

const fr_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration e-mail`)
};

const es_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de correo electrónico`)
};

const it_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrazione email`)
};

const nl_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailintegratie`)
};

const pl_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integracja z e-mailem`)
};

const fi_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköpostiin integrointi`)
};

const da_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail-integration`)
};

const sv_settings_feature_email_integration = /** @type {(inputs: Settings_Feature_Email_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postintegration`)
};

/**
* | output |
* | --- |
* | "Email integration" |
*
* @param {Settings_Feature_Email_IntegrationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_email_integration = /** @type {((inputs?: Settings_Feature_Email_IntegrationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Email_IntegrationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_email_integration(inputs)
	if (locale === "fr") return fr_settings_feature_email_integration(inputs)
	if (locale === "es") return es_settings_feature_email_integration(inputs)
	if (locale === "it") return it_settings_feature_email_integration(inputs)
	if (locale === "nl") return nl_settings_feature_email_integration(inputs)
	if (locale === "pl") return pl_settings_feature_email_integration(inputs)
	if (locale === "fi") return fi_settings_feature_email_integration(inputs)
	if (locale === "da") return da_settings_feature_email_integration(inputs)
	if (locale === "sv") return sv_settings_feature_email_integration(inputs)
	return en_settings_feature_email_integration(inputs)
});